import { FormikErrors, FormikTouched } from "formik"

export const hasError = <Values>(
  fieldName: keyof Values,
  touched: FormikTouched<Values>,
  errors: FormikErrors<Values>
) => Boolean(touched[fieldName] && errors[fieldName])
